export interface Flag {
  enabled: boolean;
  version: string;
  platformIds: number[];
  accountIds: number[];
  /**
   * Новые отели: площадки с id не меньше этого получают новую версию
   * целиком, для любой учётки. Старые — по спискам выше.
   */
  fromPlatformId?: number;
}
export const OFF: Flag = {
  enabled: false,
  version: "off",
  platformIds: [],
  accountIds: [],
};
export function parseFlag(v: any): Flag {
  const ids = (a: unknown) =>
    Array.isArray(a) && a.every((x) => Number.isSafeInteger(x) && x > 0);
  return v &&
    typeof v.enabled === "boolean" &&
    typeof v.version === "string" &&
    v.version.length &&
    ids(v.platformIds) &&
    ids(v.accountIds) &&
    (v.fromPlatformId === undefined ||
      (Number.isSafeInteger(v.fromPlatformId) && v.fromPlatformId > 0))
    ? v
    : OFF;
}
/** R3 rollout is named accounts AND platforms. It is not an authorization policy. */
export function eligible(f: Flag, account: number, platform: number) {
  if (!f.enabled || !account || !platform) return false;
  if (f.fromPlatformId && platform >= f.fromPlatformId) return true;
  return f.accountIds.includes(account) && f.platformIds.includes(platform);
}
